/**
 * CommandCenterPage — locked placeholder for the future AI-powered
 * conversational query surface. Sub-tab under Dashboard. Managers and
 * supervisors will use NLP to surface answers from platform data.
 */

import { Command } from 'lucide-react';
import { LockedFeaturePage } from './LockedFeaturePage';

export function CommandCenterPage() {
  return (
    <LockedFeaturePage
      pageTitle="Command Center (Coming Soon)"
      title="Your AI-powered command center"
      description="Ask questions in natural language and get visual answers — no more navigating tabs and scanning tables to find what you need."
      hint="Command Center will let you ask questions like 'Who needs safety training?' or 'How is Line 3 trending this month?' and get instant visual answers drawn from your live platform data. Built for managers and supervisors who need fast, contextual insights without leaving the dashboard."
      icon={Command}
    />
  );
}

export default CommandCenterPage;
